import BaseService from './baseService';

class Pengeluaran extends BaseService {
	async getPengeluaranByCompany(opts = {}) {
		this.endPoint = '/get-all-submission';
		return this.get(opts);
  }
	async getPengeluaranByType(type,opts = {}) {
    this.endPoint = '/get-submission-accountant-type?type='+type;
		return this.get(opts);
  }
  async getPengeluaranCompanyByCategoryId(page,opts = {}) {
		this.endPoint = '/get-submission-category-company?category_id='+page.category_id +'&jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }
	async getPengeluaranUserByCategoryId(page,opts = {}) {
    this.endPoint = '/get-submission-category?category_id='+page.category_id +'&jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }
	async getPengeluaranByUser(opts = {}) {
		this.endPoint = '/get-submission-user';
		return this.get(opts);
  }
  async createPengeluaran(payload){
    this.endPoint = '/submission';
    return await this.post(payload); 
  }
  async updatePengeluaran(id,payload,opts={}){
    this.endPoint = '/submission';
    return await this.putOne(id,payload,opts);
  }
  async updateStatusPengeluaran(id,payload,opts={}){
    this.endPoint = '/update-status-submission';
    return await this.putOne(id,payload,opts);
  }
  async deletePengeluaran(id,opts={}){
    this.endPoint = '/submission';
    return await this.delete(id,opts);
  }
  async deleteSubmissionNotePengeluaran() {
    this.endPoint = '/submission-note';
    return await this.delete(id, opts);
  }
  async filterPengeluaran(payload) {
    this.endPoint = '/submissions.filter';
    return await this.post(payload);
  }
}

export default new Pengeluaran();